import React, { useEffect, useMemo } from "react";
import { getDvSourceImageUrl } from "../../../functions/themeAssets";
import { isDefaultAvatarValue } from "./boardAssetConfig";

function AssetPreview({ file, storedName, label }) {
  const localUrl = useMemo(() => (file ? URL.createObjectURL(file) : ""), [file]);
  useEffect(
    () => () => {
      if (localUrl) URL.revokeObjectURL(localUrl);
    },
    [localUrl]
  );
  const src = localUrl || (storedName ? getDvSourceImageUrl(storedName) : "");
  if (!src) {
    return <div className="sl-asset-placeholder">No image</div>;
  }
  return <img src={src} alt={`${label} preview`} className="sl-asset-image" />;
}

export default function ThemeAssetFields({
  title,
  groups,
  themeData,
  pendingFiles,
  onPickFile,
  onUpload,
  onDelete,
  isSaving,
  tourId,
}) {
  return (
    <div className="themeupdate-card sl-asset-panel" data-tour={tourId}>
      {title ? <h2 className="themeupdate-card-title">{title}</h2> : null}
      <div className={`sl-asset-groups${groups.length > 1 ? " sl-asset-groups--two" : ""}`}>
        {groups.map((group) => (
          <section key={group.title} className="sl-asset-group">
            <h3 className="sl-asset-group-title">{group.title}</h3>
            {group.fields.map((field) => {
              const stored = themeData?.[field.key];
              const pending = pendingFiles[field.key] || null;
              const showDelete =
                field.canDelete && stored && !isDefaultAvatarValue(stored, field);
              return (
                <div className="sl-asset-row" key={field.key}>
                  <p className="sl-asset-label">{field.label}</p>
                  <label className="sl-file-label">
                    <span>{pending ? pending.name : "Choose file"}</span>
                    <input
                      type="file"
                      accept="image/png"
                      disabled={isSaving}
                      onChange={(e) => {
                        onPickFile(field.key, e.target.files?.[0] || null);
                        e.target.value = "";
                      }}
                    />
                  </label>
                  <p className="sl-asset-hint">
                    * Allowed photo format: PNG.
                    <br />
                    * Image dimensions: {field.width} x {field.height} px.
                    {field.canDelete ? (
                      <>
                        <br />* Click on x to delete the image.
                      </>
                    ) : null}
                  </p>
                  <div className="sl-asset-preview">
                    <AssetPreview file={pending} storedName={stored} label={field.label} />
                    {showDelete ? (
                      <button
                        type="button"
                        className="sl-asset-delete"
                        onClick={() => onDelete(field)}
                        disabled={isSaving}
                        aria-label={`Delete ${field.label}`}
                      >
                        ×
                      </button>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </section>
        ))}
      </div>
      <div className="sl-asset-actions">
        <button
          type="button"
          className="themeupdate-btn themeupdate-btn-primary"
          onClick={onUpload}
          disabled={isSaving}
        >
          {isSaving ? "Uploading..." : "Upload"}
        </button>
      </div>
    </div>
  );
}
